import moment from 'moment';
import React from 'react';
import {DateInput} from '../../../ui/date/date';
import { classnames } from '../../../../utils/classnames';
import './datePicker.css';
import InputErrors, {withErrors} from "../inputErrors/inputErrors";
import { useTranslation } from 'react-i18next';
import Input from "../inputs/inputs";


export function DateCustomInput({value, inputFormat, outputFormat, locale, ...rest}) {
	const displayDatePicker = React.useMemo(() => {
		if (!value) {
			return true;
		}

		let momentObj = moment(value, 'DD/MM/YYYY');
		return momentObj.isValid()
	}, [value]);

	return displayDatePicker ? (
		<DatePicker value={value} inputFormat={inputFormat} outputFormat={outputFormat} locale={locale} {...rest}/>
	) : (
		<Input value={value} {...rest}/>
	);
}

export default function DatePicker({
	uniqueKey,
    label = null,
	description = null,
	required = false,
	errors = null,
	className,
	locale = null,
	display = true,
	...rest
}) {
	const { t, i18n } = useTranslation();

	const lang = React.useMemo(() => locale || i18n?.language,[locale, i18n]);

	const getKey = (element = '') => uniqueKey ? `field_${uniqueKey}${element ? '_' + element : ''}` : null;

	if (!display) {
		return null
	}

	return (
		<div className={classnames('wz-neo-date-content', (required && 'required'), (withErrors(errors) && 'error'))}>
			{label && <label className='neo-input-label' for={getKey()}>{label}{required && <span aria-label={t('widget.required-field')} className='neo-required'> *</span>}</label>}
			{description && <p className='neo-input-description' id={getKey('description')}>{description}</p>}
        	<DateInput
				locale={lang}
				id={getKey()}
				ariaDescribedBy={`${getKey('description')} ${getKey('error')}`}
				{...rest}
			/>
			<InputErrors errors={errors} id={getKey('error')}/>
		</div>
    )
}

export function BirthdatePicker({ maxDate = null, ...rest }) {
	const currentYear = new Date().getFullYear();

    return (
		<DatePicker maxDate={maxDate ? maxDate : new Date().toISOString()} maxYear={maxDate ? new Date(maxDate).getFullYear() : currentYear} {...rest} />
    );
}